import React from 'react'
import FormField from '@/components/common/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { errorTypes } from '@/utility/validation'
import { useFormContext } from 'react-hook-form'
import type { OnboardTabProps } from './onboard.types'

const OnboardNominee: React.FC<OnboardTabProps> = ({ isLoading, handleNextStep }) => {
    const methods = useFormContext()
    const { register, watch, formState: { errors } } = methods

    return (
        <>
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                <FormField
                    type='select'
                    label="Relation Type"
                    value={watch('nomineeRelation')}
                    {...register('nomineeRelation', {
                        required: 'This field is Required',
                    })}
                    error={errors?.nomineeRelation?.message as string}
                    placeholder="Select Relation Type"
                    options={[
                        { value: 'Father', label: 'Father' },
                        { value: 'Mother', label: 'Mother' },
                        { value: 'Wife', label: 'Wife' },
                        { value: 'Husband', label: 'Husband' },
                        { value: 'Brother', label: 'Brother' },
                        { value: 'Sister', label: 'Sister' },
                    ]}
                />
                <FormField
                    type='text'
                    label="Nominee Name"
                    placeholder="Enter Name"
                    {...register('nomineeName', {
                        required: 'This field is Required',
                        ...errorTypes.name,
                    })}
                    error={errors?.nomineeName?.message as string}
                />
                <FormField
                    type='number'
                    label="Phone No."
                    placeholder="Enter Phone No."
                    {...register('nomineePhone', {
                        required: 'This field is Required',
                        ...errorTypes.phone,
                    })}
                    error={errors?.nomineePhone?.message as string}
                />
                <FormField
                    type='date'
                    label="Date of Birth"
                    placeholder="Enter Date of Birth"
                    {...register('nomineeDob', {
                        required: 'This field is Required',
                    })}
                    error={errors?.nomineeDob?.message as string}
                />
            </div>
            <div className="flex justify-end mt-6">
                <Button
                    type="button"
                    onClick={() => handleNextStep('tab7', ['nomineeRelation', 'nomineeName', 'nomineePhone', 'nomineeDob'])}
                    disabled={isLoading}
                >
                    {isLoading ? <Spinner /> : 'Save and Continue'}
                </Button>
            </div>
        </>
    )
}

export default OnboardNominee
